import { ICommentsAverage } from 'modules/admin-panel/pages/results/models/IComments';
import mapStyles from './mapStyles';

interface Config extends Record<string, any> {
	options: google.maps.MapOptions;
}

export interface IMarkerSizeExtremums {
	size: {
		min: number;
		max: number;
	};
	maxCount: number;
}

export const RESULT_MAP_CONFIG: Config = {
	libraries: ['places'],

	mapContainerStyle: {
		height: '392px',
		width: '100%',
		borderRadius: '4px',
	},

	options: {
		styles: mapStyles,
		disableDefaultUI: true,
		zoomControl: true,
		minZoom: 1,
		panControl: true,
		scrollwheel: false,
	},

	center: {
		lat: 0,
		lng: 0,
	},
};

export const GLOBAL_DEFAULT_ZOOM = 5;
export const COUNTRY_DEFAULT_ZOOM = 8;
export const CITY_DEFAULT_ZOOM = 12;
export const OFFICE_DEFAULT_ZOOM = 14;

export const getMaxCount = (markerList: ICommentsAverage[]) => {
	const counts = markerList.map((i) => i.count || 0);
	return Math.max(...counts);
};

export const getMarkerSizeExtremums = (
	maxRespondentCount: number,
): IMarkerSizeExtremums => {
	if (maxRespondentCount <= 20) {
		return {
			size: {
				min: 8,
				max: 11,
			},
			maxCount: maxRespondentCount,
		};
	}

	if (maxRespondentCount <= 100) {
		return {
			size: {
				min: 8,
				max: 15,
			},
			maxCount: maxRespondentCount,
		};
	}

	if (maxRespondentCount <= 500) {
		return {
			size: {
				min: 4,
				max: 25,
			},
			maxCount: maxRespondentCount,
		};
	}

	return {
		size: {
			min: 4,
			max: 30,
		},
		maxCount: 1000,
	};
};

export const calculateMapDotSize = (
	sizeExtremums: IMarkerSizeExtremums,
	respondentCount: number,
) => {
	const sizePerCount =
		(sizeExtremums.size.max - sizeExtremums.size.min) / sizeExtremums.maxCount;
	return Math.round(sizePerCount * respondentCount + sizeExtremums.size.min);
};
